import React from 'react';
import './SpiritualRobot.css';

export default function SpiritualRobot({ onClick }) {
  return (
    <div
      className="spiritual-robot-container"
      onClick={onClick}
      data-testid="fa-launcher"
      role="button"
      tabIndex={0}
    >
      {/* Outer Cosmic Aura */}
      <div className="cosmic-aura" />
      <div className="cosmic-aura aura-2" />
      
      {/* Zodiac Ring */}
      <div className="zodiac-ring">
        <span className="zodiac-symbol z1">&#9800;</span>
        <span className="zodiac-symbol z2">&#9801;</span>
        <span className="zodiac-symbol z3">&#9802;</span>
        <span className="zodiac-symbol z4">&#9803;</span>
        <span className="zodiac-symbol z5">&#9804;</span>
        <span className="zodiac-symbol z6">&#9805;</span>
        <span className="zodiac-symbol z7">&#9806;</span>
        <span className="zodiac-symbol z8">&#9807;</span>
        <span className="zodiac-symbol z9">&#9808;</span>
        <span className="zodiac-symbol z10">&#9809;</span>
        <span className="zodiac-symbol z11">&#9810;</span>
        <span className="zodiac-symbol z12">&#9811;</span>
      </div>

      {/* Robot Body */}
      <div className="robot-body">
        {/* Head */}
        <div className="robot-head">
          {/* Third Eye */}
          <div className="third-eye">
            <div className="third-eye-inner" />
          </div>
          {/* Eyes */}
          <div className="robot-eyes">
            <div className="robot-eye left-eye">
              <div className="eye-pupil" />
              <div className="eye-shine" />
            </div>
            <div className="robot-eye right-eye">
              <div className="eye-pupil" />
              <div className="eye-shine" />
            </div>
          </div>
          {/* Mouth - gentle smile */}
          <div className="robot-mouth" />
          {/* Antenna */}
          <div className="antenna">
            <div className="antenna-orb" />
          </div>
        </div>

        {/* Torso */}
        <div className="robot-torso">
          {/* Om Symbol */}
          <div className="om-symbol">&#x0950;</div>
          {/* Energy Core */}
          <div className="energy-core" />
        </div>

        {/* Arms */}
        <div className="robot-arm left-arm">
          <div className="hand">
            <div className="blessing-glow" />
          </div>
        </div>
        <div className="robot-arm right-arm">
          <div className="hand">
            <div className="blessing-glow" />
          </div>
        </div>
      </div>

      {/* Floating Particles */}
      <div className="particle p1" />
      <div className="particle p2" />
      <div className="particle p3" />
      <div className="particle p4" />
      <div className="particle p5" />
      <div className="particle p6" />

      {/* Label */}
      <div className="robot-label">Ask Guruji</div>
    </div>
  );
}
